﻿import {getCookie, setCookie} from '../../utils';

const popup = () => {
    const popupElement = document.querySelector('[data-popup]') as HTMLElement;
    if (!popupElement) return;

    let popupCount: number;
    const popupName = popupElement.getAttribute('data-popup-name');
    const popupFrequency = Number(popupElement.getAttribute('data-popup-session-frequency'));
    const popupTrigger = popupElement.getAttribute('data-popup-trigger');
    const sessionCookieName = popupName;
    const sustainedCookieName = popupName + 'Sustained';
    let popupCookieVal: string | null;
    const sustainedPopupCookieVal = getCookie(sustainedCookieName);

    popupCount = sustainedPopupCookieVal ? Number(sustainedPopupCookieVal) : 0;

    if (popupTrigger === 'onload') {
        popupCookieVal = getCookie(sessionCookieName);

        if (popupCookieVal !== 'v' && popupCount < popupFrequency) {
            setCookie(sessionCookieName, 'v', '0.08');
            setCookie(sustainedCookieName, String(popupCount + 1), '60');
            popupElement.classList.add('is-active');
        } else {
            setCookie(sessionCookieName, 'v', '0.08');
        }
    }

    popupElement.addEventListener('click', () => {
        popupElement.classList.remove('is-active');
    });

    const closeBtn = popupElement.querySelector('[data-close-popup]');
    closeBtn?.addEventListener('click', () => {
        popupElement.classList.remove('is-active');
    });

    const content = popupElement.querySelector('.popup__content');
    content?.addEventListener('click', (event) => {
        event.stopPropagation();
    });
};

export const init = () => {
    popup();
};

